export const PATH = "/cdn/schiffsbesichtigung/#/";
export const Model = {
    jwt: "",
    customer: null,
    schedule: null,
    visitors: null,
    wasAlreadyGuest: null,
    schedules: {
        sea: null,
        river: null,
    },
    payment: {
        iban: null,
        method: null,
    },
    webtexts: null,
    nations: null,
    customerFromDatabase: false,
};
export const Shiptypes = {
    fluss: "Flussschiffe",
    see: "Hochseeschiffe",
};
export default Model;
